// Make the height of the Bootstrap carousel items the same
function normalizeSlideHeights() {
    $('.carousel').each(function() {
        var items = $('.carousel-item', this);
        // reset the height
        items.css('min-height', 0);
        // set the height
        var maxHeight = Math.max.apply(
            null,
            items
                .map(function() {
                    return $(this).outerHeight();
                })
                .get()
        );
        items.css('min-height', maxHeight + 'px');
    });
}
$(window).on('load resize orientationchange', normalizeSlideHeights);



// WEBPACK FOOTER //
// ./scripts/routes/other/bootstrap-custom.js